import {
    IB_TREES_FETCH,
    IB_TREES_IS_FETCING,
    IB_TREE_FILTER,
    IB_TREE_EDIT,
    SET_IBTREE_PROFILE,
    SET_IBTREE_IB,
} from 'constants/ibTrees'

export default function ibTreesReducer(state = {
    list: [],
    pageable: {
        sort: {
            'ibTreeId': 'asc',
        },
        filter: {},
        size: 10,
        page: 0,
        totalPages: 0,
        totalElements: 0,
    }
}, action) {
    switch (action.type) {
        case IB_TREES_FETCH:
            return {
                ...state,
                list: action.payload,
            }
        case IB_TREE_EDIT:
            return {
                ...state,
                // list: state.list.find(e=>state.ibTreeId===e.ibTreeId)?,
            }
        case IB_TREES_IS_FETCING:
            return {
                ...state,
                isFetching: action.payload,
            }
        case SET_IBTREE_PROFILE:
            return {
                ...state,
                selectedProfileId: action.payload.profileId,
                selectedProfileName: action.payload.profileName
            }
        case SET_IBTREE_IB:
            return {
                ...state,
                selectedIbId: action.payload.ibId,
                selectedIbName: action.payload.ibName
            }
        case IB_TREE_FILTER:
            return {
                ...state,
                pageable: {
                    ...state.pageable,
                    ...action.payload,
                    sort: action.payload.sort ? {
                        ...Object.keys(state.pageable.sort).reduce((obj, i) => ({
                            ...obj,
                            [i]: false
                        }), {}),
                        ...action.payload.sort
                    } : state.pageable.sort,
                },
            }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/ibTrees.js